import React, { useState } from 'react';
import {
    Button, Form, FormFeedback, FormGroup, Input, Label, ModalBody, ModalFooter, Row,
    Card, Table, CardSubtitle,Col,InputGroup ,InputGroupAddon ,InputGroupText 
} from 'reactstrap';
import { nameID, nameadd, sociall, rfcf, defaut, referenceLaboratories, save, cancell } from '../../constant';
import Select from 'react-select';
import { cedimi, semlab, pyrsa, demo, labcen, sharp } from '../../constant/globalConstantsTypeClients';
import { FilterMatchMode } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';

export const UpdateExam = (props) => {


    const { formValues, closeDialog, handleInputChange, validaciones, loading,
        sections, changeSelect, specimenOrigins, specimens, specimenProvenances, subSections, transports,
        id_section, id_subsection, id_specimen_origin,
        code, alias, name, abbreviation, individual_sale, is_referenced, is_critic,
        listExternalLaboratories, examId,
        getUpdateDefaultExternalLaboratory, methodAction, handleSelectValues, print_new_page,
           //*CONFIGURATION EXTERNAL LABORATORY
           dataLaboratory,handleChangePriceIni, 
           //* CURVES
           is_curve, showCurveField 
    } = props;
           console.log("🚀 ~ UpdateExam ~ dataLaboratory:", dataLaboratory)

    //console.log(dataLaboratory);

    const {
        code: validationCode,
        alias: validationAlias,
        name: validationName,
        abbreviation: validationAbbreviation,
        id_section: validationSection,
        id_specimen_origin: validationSpecimenOrigen
    } = validaciones;
    const txtsection = localStorage.getItem('TextAS');
    let url_helen = localStorage.getItem('url_helen');
    const isCedimi = url_helen === cedimi;
    const isSemlab = url_helen === semlab;
    const isPyrsa = url_helen === pyrsa;
    const isDemo = url_helen === demo;
    const isLabcen = url_helen === labcen
    const isSharp = url_helen === sharp;

    const showCurves = showCurveField && (isCedimi || isSemlab || isPyrsa || isDemo || isLabcen || isSharp);

    const fieldCol = showCurves
    ? "col-6 col-sm-6 col-md-4 col-lg-2"
    : "col-6 col-sm-6 col-md-4 col-lg-3";

    const curveCol = "col-6 col-sm-6 col-md-4 col-lg-2";




   const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    return (
        <Form className="" role="form" onSubmit={methodAction}>
          
            <div>
            </div>

            <Row>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-3">
                    <Label className="f-w-600 f-12 badge badge-light-secondary">
                        Clave
                        <span className="f-16" style={{ color: "#0079C7" }}>*</span>
                    </Label>

                    <Input
                        className="form-control form-control-sm input-air-primary w-100"
                        type="text"
                        name="code"
                        value={code}
                        required
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationCode}
                    />

                    <FormFeedback>
                        El código debe tener 3 o más caracteres
                    </FormFeedback>
                </FormGroup>

                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-3">
                    <Label className='f-w-600 f-12 badge badge-light-secondary'>Alias <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="text"
                        name="alias"
                        value={alias}
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAlias}
                    />
                    <FormFeedback>El alias debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-3">
                    <Label className='f-w-600 f-12 badge badge-light-secondary' >Abreviatura <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="text"
                        name="abbreviation"
                        value={abbreviation}
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationAbbreviation}
                    />
                    <FormFeedback>La abreviatura debe tener 2 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-3">
                    <Label className='f-w-600 f-12 badge badge-light-secondary' >Tiempo de entrega<span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        value={formValues.delivery_time}
                        type="text"
                        name="delivery_time"
                        required={false}
                        autoComplete="off"
                        onChange={handleInputChange}
                    />
                    <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
            </Row>
            <Row>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-6 col-lg-6">
                    <Label className='f-w-600 f-12 badge badge-light-secondary' >Nombre del exámen <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="text"
                        name="name"
                        value={name}
                        required={true}
                        autoComplete="off"
                        onChange={handleInputChange}
                        invalid={validationName}
                    />
                    <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-6 col-lg-6">
                    <Label className='f-w-600 f-12 badge badge-light-secondary' >{txtsection} <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Input
                        className="form-control form-control-sm input-air-primary"
                        type="select"
                        name="id_section"
                        required={true}
                        onChange={handleInputChange} 
                        invalid={validationSection || id_section === "0"}
                        value={id_section}
                    >
                        <option value={0}>Selecciona una opción</option>
                        {
                            sections.length > 0 && sections.map((s, key) => {
                                return <option
                                    key={key} value={s.id_section}
                                >
                                    {s.name}
                                </option>
                            })
                        }
                    </Input>
                    {id_section === 0 && <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>}
                    {/* <FormFeedback>Debes seleccionar al menos una opción</FormFeedback> */}
                </FormGroup>

            </Row> <br />
            <Row>

                {/* <FormGroup className="mb-3 col-3">
                    <Label>Subsección</Label> <br />
                    <Input
                        className="form-control form-control-sm input-air-primary "
                        type="select"
                        name="id_subsection"
                        required={true}
                        onChange={handleInputChange}
                        value={id_subsection}
                    >
                        <option value={0}>Selecciona una opción</option>
                        {
                            subSections.length > 0 && subSections.map((ss, key) => {
                                return <option
                                    key={key} value={ss.id_subsection}
                                >
                                    {ss.name}
                                </option>
                            })
                        }
                    </Input>
                </FormGroup> */}
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4">
                    <Label className='f-w-600 f-12 badge badge-light-secondary'>Tipo de muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>

                    <Select
                        value={formValues.id_specimen}
                        classNamePrefix="select"
                        name="id_specimen"
                        placeholder={`Selección de especimen`}
                        isClearable={false}
                        noOptionsMessage={() => "Sin opciones"}
                        options={specimens}
                        onChange={(e) => handleSelectValues(e, "id_specimen")}
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                        }}
                    />
                    <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4">
                    <Label className='f-w-600 f-12 badge badge-light-secondary' >Procedencia de la muestra <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Select
                        value={formValues.id_specimen_provenance}
                        classNamePrefix="select"
                        name="id_specimen_provenance"
                        placeholder={`Seleciona la procedencia`}
                        isClearable={false}
                        noOptionsMessage={() => "Sin opciones"}
                        options={specimenProvenances}
                        onChange={(e) => handleSelectValues(e, "id_specimen_provenance")}   
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999 
                            })
                        }}                 
                        />
                    <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                </FormGroup>
                <FormGroup className="mb-3 col-12 col-sm-6 col-md-4 col-lg-4">
                    <Label className='f-w-600 f-12 badge badge-light-secondary' >Medio(s) de transporte <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                    <Select
                        value={formValues.list_transports}
                        isMulti
                        classNamePrefix="select"
                        name="list_transports"
                        onChange={(e) => handleSelectValues(e, "list_transports")}
                        // value={valuePeriod}
                        placeholder={`Selección de medio de transporte`}
                        isClearable={false}
                        noOptionsMessage={() => "Sin opciones"}
                        options={transports}
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                            })
                        }}
                    />
                    <FormFeedback>Debes seleccionar al menos una opción</FormFeedback>
                </FormGroup>
                
            </Row>
            <Row>


                            
            </Row>
            <Row>
            <Col className={fieldCol}>
                <FormGroup className="d-flex flex-column align-items-center">
                    <Label>Venta individual</Label>
                    <Label className="switch mt-1">
                        <Input
                            type="checkbox"
                            checked={formValues.individual_sale}
                            name="individual_sale"
                            onChange={handleInputChange}
                        />
                        <span className="slider round"></span>
                    </Label>
                </FormGroup>
            </Col>
 <Col className="col-6 col-sm-6 col-md-4 col-lg-3">
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>¿Es referenciado?</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.is_referenced}
                                    name="is_referenced"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col className={fieldCol}>
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>¿Es crítico?</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.is_critic}
                                    name="is_critic"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    <Col className="col-5 col-sm-6 col-md-4 col-lg-3">
                        <FormGroup className="d-flex flex-column align-items-center">
                            <Label>¿Impresión en una hoja diferente?</Label>
                            <Label className="switch mt-1">
                                <Input
                                    type="checkbox"
                                    checked={formValues.print_new_page}
                                    name="print_new_page"
                                    onChange={handleInputChange}
                                />
                                <span className="slider round"></span>
                            </Label>
                        </FormGroup>
                    </Col>

                    {showCurves && (
                        <Col className={curveCol}>
                            <FormGroup className="d-flex flex-column align-items-center">
                                <Label>¿Es Curva?</Label>
                                <Label className="switch mt-1">
                                    <Input
                                        type="checkbox"
                                        checked={formValues.is_curve}
                                        name="is_curve"
                                        onChange={handleInputChange}
                                    />
                                    <span className="slider round"></span>
                                </Label>
                            </FormGroup>
                        </Col>
                    )}
            </Row>


            {
                ////console.log(listExternalLaboratories)
            }

           <div className={listExternalLaboratories !== null && listExternalLaboratories.length >= 1 && is_referenced} >     
                {
                    formValues.is_referenced &&
                    <Col sm="12" className="container-global-zoom">
                        <div className="position-relative mb-3" style={{ minHeight: "50px" }}>
                            
                            <div className="ribbon ribbon-clip ribbon-primary">
                                Asignar Precios a Laboratorios Externos
                            </div>

                            <div
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    right: 0,
                                    transform: "translateY(-50%)",
                                    width: "250px"
                                }}
                            >
                                <InputText
                                    type="search"
                                    value={filters.global.value || ""}
                                    onChange={(e) =>
                                        setFilters({
                                            global: {
                                                value: e.target.value || null,
                                                matchMode: FilterMatchMode.CONTAINS
                                            }
                                        })
                                    }
                                    placeholder="Buscar..."
                                    className="w-100"
                                    showClear
                                />
                            </div>
                        </div>
                                                


                        <div className="table-responsive ">
                            <DataTable 
                                value={dataLaboratory}
                                filters={filters}
                                filterDisplay="menu"
                                globalFilterFields={['external_laboratory']}
                                className="data-table p-datatable-striped p-datatable-sm"
                                emptyMessage={
                                    <div className="text-center">
                                        <img
                                            src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                            style={{ width: "40%" }}
                                            alt="Sin laboratorios"
                                        />
                                        <br />
                                        <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                            Sin Laboratorios.
                                        </p>
                                    </div>
                                }
                                // scrollable             
                                // scrollHeight="200px"
                                paginator
                                rows={10}
                                rowsPerPageOptions={[10, 50, 100]}
                                    responsiveLayout="scroll"


                                >


                                <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                <Column field="external_laboratory" header="Laboratorio"  headerStyle={headerStyle} style={centerStyle} />
                                <Column 
                                    header="Precio"
                                    body={(rowData) => {
                                        return (
                                            <div 
                                                style={{ 
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                gap: "5px",
                                                width: "100%" 
                                                }}
                                            >
                                                <div className="price-input-wrapper">
                                                    <i className="fa fa-usd price-icon"></i>
                                                    <InputNumber
                                                        // className="input-air-primary"
                                                        min={0}
                                                        step="any"
                                                        value={rowData.price}
                                                        name='amount'
                                                        allowEmpty
                                                        locale="en-US"
                                                        maxFractionDigits={2} 
                                                        onChange={(e) =>
                                                            handleChangePriceIni(
                                                                { target: { value: e.value, name: 'amount' } },
                                                                rowData.id_external_laboratory
                                                            )
                                                        }
                                                    

                                                    />
                                                    
                                                </div>
                                            </div>
                                        );
                                    }}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />
                                <Column 
                                    header="Costo"
                                    body={(rowData) => {
                                    
                                        return (
                                            <div 
                                                style={{ 
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                gap: "5px",
                                                width: "100%" 
                                                }}
                                            >
                                            <div className="price-input-wrapper">
                                                    <i className="fa fa-usd price-icon"></i>

                                                    <InputNumber
                                                        className="input-air-primary price-input"
                                                        value={rowData.cost}
                                                        min={0}
                                                        step="any"
                                                        name="cost"
                                                        locale="en-US"
                                                        maxFractionDigits={2} porquwe
                                                        allowEmpty
                                                        style={{ zIndex: 1 }}
                                                        onChange={(e) =>
                                                            handleChangePriceIni(
                                                                { target: { value: e.value, name: 'cost' } },
                                                                rowData.id_external_laboratory
                                                            )
                                                        }
                                                    
                                                    />
                                                </div>

                                            
                                            </div>
                                        );
                                    }}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />         
                                
                                <Column 
                                    header="Default"
                                    body={(rowData) => {
                                    
                                        return (
                                            <div 
                                                style={{ 
                                                display: "flex", 
                                                flexDirection: "column", 
                                                alignItems: "center", 
                                                justifyContent: "center",
                                                gap: "5px",
                                                width: "100%" 
                                                }}
                                            >
                                            <RadioButton 
                                                inputId="defaultLabKey"
                                                name="default_lab"
                                                value={rowData.default_lab}
                                                onChange={(e) => handleChangePriceIni(e,rowData.id_external_laboratory )}
                                                checked={rowData.default_lab}
                                                style={{ zIndex: 1 }}
                                                />


                                            </div>
                                        );
                                    }}
                                    headerStyle={headerStyle}
                                    style={cellStyle}
                                />         
                                
                            </DataTable>
                        </div>  

                    </Col>
                }
      
            </div>
            <ModalFooter>
                <Button
                    color="secondary"
                    type="submit"
                    className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}>
                    {save}
                </Button>
                <Button color="danger" type="button" onClick={closeDialog}>{cancell}</Button>
            </ModalFooter>
        </Form>
    )
}
